module.exports = __webpack_public_path__ + "4da4620ffad5c3e16be807a1d893daef.svg";